import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 30000,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("rk_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const adminApi = axios.create({
    baseURL: API,
    timeout: 30000,
});
adminApi.interceptors.request.use((config) => {
    const token = localStorage.getItem("rk_admin_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const formatINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
    }).format(amount);
};

export const categoryIcon = (category) => {
    const map = {
        "Jewellery": "gem",
        "Travel": "plane",
        "Hotels": "hotel",
        "Electronics": "smartphone",
        "Apparel": "shirt",
        "Food & Beverage": "utensils",
        "Groceries": "shopping-basket",
        "Online Shopping": "shopping-bag",
        "Watches": "watch",
        "Sports": "dumbbell",
        "Wellness": "heart-pulse",
        "Home & Furniture": "sofa",
        "Home Appliances": "zap",
        "Digital Gold": "coins",
        "Subscription": "tv",
        "Services": "briefcase",
        "Shopping": "shopping-cart",
    };
    return map[category] || "gift";
};
